const FinishingLayer = () => {
	return (
		<svg
			width="997"
			height="613"
			viewBox="0 0 997 613"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M497.091 1020C421.832 1020 353.663 1006.93 292.583 980.804C231.503 954.673 179.149 918.925 135.612 873.56C91.9832 828.194 58.5348 774.391 35.0845 712.058C11.6342 649.726 0 582.403 0 510C0 437.596 11.7251 370.274 35.0845 307.942C58.5348 245.609 91.9832 191.806 135.612 146.44C179.24 101.075 231.503 65.3264 292.583 39.1959C353.663 13.0653 421.832 0 497.091 0C572.35 0 642.156 13.0653 703.69 39.1959C765.224 65.3264 817.76 101.075 861.388 146.44C905.017 191.806 938.465 245.609 961.916 307.942C985.366 370.274 997 437.596 997 510C997 582.403 985.275 649.726 961.916 712.058C938.465 774.391 905.017 828.194 861.388 873.56C817.76 918.925 765.224 954.673 703.69 980.804C642.156 1006.93 573.35 1020 497.091 1020ZM497.091 985.704C561.352 985.704 616.887 973.546 663.697 949.139C710.507 924.823 748.863 891.434 778.676 849.244C808.489 806.963 830.576 756.88 844.755 698.993C858.934 641.107 866.115 578.139 866.115 510.091C866.115 442.042 859.025 379.166 844.755 321.188C830.485 263.302 808.489 212.946 778.676 170.212C748.863 127.477 710.507 94.179 663.697 70.226C616.887 46.3637 561.352 34.3871 497.091 34.3871C432.83 34.3871 377.749 46.3637 331.849 70.226C285.948 94.179 248.046 127.477 218.233 170.212C188.42 212.946 166.333 263.211 152.154 321.188C137.884 379.075 130.794 442.042 130.794 510.091C130.794 578.139 138.157 641.107 152.79 698.993C167.424 756.88 189.965 806.963 220.233 849.244C250.5 891.525 288.584 924.823 334.575 949.139C380.476 973.455 434.648 985.704 497.091 985.704Z"
				fill="url(#paint0_linear_3523_14563)"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_3523_14563"
					x1="498.5"
					y1="0"
					x2="498.5"
					y2="614.5"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" stopOpacity="0" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
			</defs>
		</svg>
	)
}

export default FinishingLayer
